<template>
  <div class="groupCode">
    <innerWarp v-if="$store.state.isMobile">
      <slot>
        <div v-if="!showSuccess && !showAddMember" class="content">
          <div class="title">请输入团队邀请码</div>
          <div class="inputCode">
            <input v-model="code" maxlength="4" type="number" oninput="if(value.length>4)value=value.slice(0,4)">
            <div :class="`inputWarp warp_${n} ${n == code.length + 1 ? 'focused' : ''}`" v-for="n in 4" :key="n"></div>
          </div>
          <div class="buttonConfirm" @click="submitData">确&nbsp;定</div>
        </div>
        <div v-if="showAddMember" class="codeAddMember">
          <addMember @submitAdd="submitAdd" :editData="editData" addType="add"></addMember>
        </div>
        <div v-if="showSuccess" class="content">
          <img src="~@/assets/wen_write.png"/>
          <div class="title">信息提交成功</div>
          <div class="buttonConfirm" @click="toIndex">返回主页</div>
        </div>
      </slot>
    </innerWarp>
    <div v-else class="pcWarp">
      <topBanner></topBanner>
      <div v-if="!showSuccess && !showAddMember" class="content">
        <div class="title">请输入团队邀请码</div>
        <div class="inputCode">
          <input v-model="code" maxlength="4" type="number" oninput="if(value.length>4)value=value.slice(0,4)">
          <div :class="`inputWarp warp_${n} ${n == code.length + 1 ? 'focused' : ''}`" v-for="n in 4" :key="n"></div>
        </div>
        <div class="buttonConfirm" @click="submitData">确&nbsp;定</div>
      </div>
      <div v-if="showAddMember" class="codeAddMember">
        <addMember @submitAdd="submitAdd" :editData="editData" addType="add"></addMember>
      </div>
      <div v-if="showSuccess" class="content">
        <img src="~@/assets/wen_write.png"/>
        <div class="title">信息提交成功</div>
        <div class="buttonConfirm" @click="toIndex">返回主页</div>
      </div>
    </div>
  </div>
</template>

<script>
import innerWarp from '../../components/common/innerWarp.vue'
import addMember from '../../components/ticket/addMember.vue'
import topBanner from '../../components/common/topBanner'

export default {
  data() {
    return {
      code: '',
      showSuccess: false,
      editData: {},
      showAddMember: false,
    };
  },

  components: {innerWarp, addMember, topBanner},


  methods: {
    submitAdd(data) {
      if (this.addType == 'edit') return this.editPersonal(data)
      for (let key in data) {
        if (!data[key]) {
          return this.$message.error('请将个人信息填写完整！')
        }
      }
      this.postAddPersonal(data)
    },

    postAddPersonal(data) {
      data.museumCode = this.$route.query.museumCode
      data.cardType = 1
      data.belongId = this.$route.query.belongId
      data.personType = 1
      this.$ajax.post(`/api/ticket/front/people/team-people?code=${this.code}`, data).then((res) => {
        this.showSuccess = true
      })
    },

    submitData() {
      this.$ajax(`/api/ticket/front/people/verify-code?code=${this.code}&id=${this.$route.query.belongId}`).then((res) => {
        this.showAddMember = true
      })
    },

    toIndex() {
      this.$router.replace(`/ticket/home?museumCode=${this.$route.query.museumCode}`)
    }
  },

  created() {
    
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.groupCode{
  .content{
    margin-top: 1rem;
  }
  .title{
    // margin-top: 2rem;
    font-size: 0.6rem;
    font-weight: 500;
  }
}
</style>
<style type="text/css" lang="scss">
  .groupCode input{
    border: unset;
    letter-spacing: 1.2rem;
    margin: 0.5rem;
    width: 7rem;
    height: 2rem;
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 500;
    background-color: rgba(0,0,0,0);
    z-index: 5;
    outline: none;
    padding-left: 1rem;
  }
  .groupCode .el-input{
    background-color: rgba(0,0,0,0);
    z-index: 5;
  }
  .groupCode .inputCode{
    position: relative;
    margin: 0.5rem 0 0.5rem 0.5rem;
    // margin-left: 0.5rem;
  }
  .inputWarp{
    height: 1.8rem;
    width: 1.4rem;
    border-radius: 0.4rem;
    border: 1px solid #e5e5e5;
    position: absolute;
    top: 0.6rem;
    z-index: -1;
  }
  .warp_1 {
    left: 1.25rem;
  }
  .warp_2{
    left: 3rem;
  }
  .warp_3{
    left: 4.75rem;
  }
  .warp_4{
    left: 6.55rem;
  }
  .groupCode{
    img{
      width: 4rem;
      // margin-top: 1rem;
    }
  }
  .groupCode{
    .pcWarp{
      .content{
        margin-top: 0.2rem;
        .title{
          font-size: 0.3rem;
        }
        .inputCode{
          margin-top: 0.1rem;
          width: 6rem;
          margin: auto;
          input{
            height: 1.2rem;
            width: 5rem;
            padding-left: 0.8rem;
            line-height: 1rem;
            font-size: 0.6rem;
            letter-spacing: 0.7rem;
          }
          overflow: hidden;
        }
        .inputWarp{
          width: 0.5rem;
          height: 1rem;
        }
        .warp_1{
          left: 1.2rem;
        }
        .warp_2{
          left: 2.23rem;
        }
        .warp_3{
          left: 3.26rem;
        }
        .warp_4{
          left: 4.29rem;
        }
        .buttonConfirm{
          width: 1.8rem;
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 0.3rem;
        }
      }
    }
  }
</style>

<style>
  .codeAddMember input{
    width: 4rem !important;
    height: 1rem !important;
    letter-spacing: unset !important;
    margin: unset;
  }
</style>






